import * as React from "react";
import { SVGProps } from "react";
const Checked = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={11} cy={11} r={10} stroke="currentColor" strokeWidth={2} />
    <path
      d="M6 11.5L9.33333 15L16 8"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
export default Checked;
